import Card from './Card';
import Badge from './Badge';
import Button from './Button';
import Typography from './Typography';
import NumberFormat from './NumberFormat';
import Alert from './Alert';
import DateTimePicker from './DateTimePicker';
import Zoom from './Zoom';
import DatePicker from './DatePicker';
import Tooltip from './Tooltip';
import SectionLabelContainer from '../SectionLabelContainer';
import Progress from './Progress';
import BadgeCampaign from './BadgeCampaign';
import BadgeStatus from './BadgeStatus';
import Dialog from './Dialog';
import ButtonDropDown from './ButtonDropdown';
import AudioPlayer from './AudioPlayer';
import Separator from './Separator';
import FlashContainer from './FlashContainer';

const NewDesign = {
  Zoom,
  Alert,
  Card,
  Badge,
  Button,
  Typography,
  NumberFormat,
  DateTimePicker,
  DatePicker,
  Tooltip,
  SectionLabelContainer,
  Progress,
  BadgeCampaign,
  BadgeStatus,
  Dialog,
  ButtonDropDown,
  AudioPlayer,
  Separator,
  FlashContainer,
};

export default NewDesign;
